import React, { useState, useContext } from 'react'
import Logo from '../assets/ML REVIEWED.png';
import { Link, useNavigate } from 'react-router-dom';
import { FaRegUserCircle } from "react-icons/fa";
import { MdOutlineCameraAlt } from "react-icons/md";  
import { useToken } from '../contex/TokenProvider';
import '../Style/Header.css';
import useAuth from '../hooks/useAuth';
import AuthContext from '../contex/AuthProvider';

function Header() {

  const { auth } = useContext(AuthContext);
  const user = auth.user;

    const { setToken } = useToken();  
    const { setAuth } = useAuth();
    const navigate = useNavigate();  
    const [profile, setProfile] = useState();

    const handleLogout = () => {    
        setToken(null);  
        setAuth({ user: null });
        localStorage.removeItem('token');  

        navigate('/');  
    };



  return (
    <div className='header-container'>
      <div className='bg-green-500 text-white'>
        <div className='mr-[50px] ml-[10px] flex flex-row justify-between items-center h-[70px] px-[70px]'>
          <div className='w-[150px]'>
            <Link to={'/'}><img className='w-[100%]' src={Logo} /></Link>
          </div>

          <div>
            <h1 className='text-[16px] font-bold'>MERCYLAND GROUP ADMIN PANEL</h1>
          </div>

          <div className='flex flex-row items-center gap-5'>
            <div className='user relative w-12 h-12 overflow-hidden rounded-full'>

            {user ? (  
              <div  
                className="profile absolute inset-0 bg-cover bg-center"  
                style={{ backgroundImage: `url(${user.profileImage})` }} // Ensure the URL is wrapped in `url()`  
              ></div>  
                  ) : (  
                    <FaRegUserCircle className="w-full h-full text-gray-400" /> // Provide size and color to the icon  
                  )}
              {/* <button>
                {user ? <img src={user.profileImage} /> : <FaRegUserCircle />}
                <input type='file' /> 
              </button> */}
            </div>
            <button onClick={handleLogout} className="border-2 border-slate-500 hover:bg-slate-500 text-white text-[12px] px-4 py-2 cursor-pointer">  
              Logout  
            </button>
          </div>
          
        </div>
      </div>
    </div>
    
  )
}

export default Header
